export const categories = {
  Common: [
    'Medical Device',
    'Household Items',
    'Extraneous Material',
    'Clothing and Accessories',
    'Tools and Electrical Products',
    'Electronics',
    'Equipment',
    'Cosmetics',
    'Outdoor Living',
    'Specialized Products',
    'Appliances',
    'Jewellery',
    'Hobby/Craft Items',
    'Labelling',
    'Marine Biotoxin',
    'Nutrition',
    'Tampering',
    'Non-permitted Food Ingredients',
    'Cyanide Poisoning',
  ],
  Allergens: [
    'Allergen - Milk',
    'Allergen - Egg',
    'Allergen - Sulphites',
    'Allergen - Wheat',
    'Allergen - Mustard',
    'Allergen - Gluten',
    'Allergen - Soy',
    'Allergen - Tree Nut',
    'Allergen - Peanut',
    'Allergen - Sesame Seeds',
    'Allergen - Crustacean/Shellfish',
    'Allergen - Fish',
    'Allergen - Other',
    'Allergen - Coconut',
  ],
  Microbes: [
    'Microbiological - Non harmful (Quality/Spoilage)',
    'Microbiological - Salmonella',
    'Microbiological - Listeria',
    'Microbiological - Clostridium botulinum',
    'Microbiological - Staphylococcus aureus',
    'Microbiological - E. coli O157:H7',
    'Microbiological - E. coli O157',
    'Microbiological - E. coli O26',
    'Microbiological - E. coli O103',
    'Microbiological - E. coli O121',
    'Microbiological - E. coli O126',
    'Microbiological - pathogenic E. coli',
    'Microbiological - Other',
  ],
  Children: [
    "Children's Products",
    'Toys',
    'Affects children',
    'Child Car Seat',
    'pregnant or breast feeding women',
    'Booster Seat',
  ],
  Drugs: [
    'Drugs',
    'Natural health products',
    'Biologic/vaccine',
    'Veterinary Drugs',
    'Vaccines',
    'Radiopharmaceuticals',
  ],
  Vehicles: [
    'Car',
    'Truck - Med. & H.D.',
    'Light Truck & Van',
    'SUV',
    'Motorhome',
    'Motorcycle',
    'Travel Trailer',
    'Heavy Trailer',
    'Bus',
    'School Bus',
    'Minivan',
    'A.T.V.',
    'Snowmobile',
    'Light Trailer',
    'Minibike/ Moped /Scooter',
    '3 Wheel Motorcycle',
    'Low Speed Motorcycle',
    'Low Speed Vehicle',
    'Three Wheeled Vehicle',
    'Three Wheeled Motorcycle',
    '3 Wheel Car',
    'Competition Snowmobile',
    'RV Chassis',
    'Tire',
    'Chassis Cab',
    'Snowmobile Cutter',
  ],
  Cannabis: ['Cannabis', 'Medical Cannabis', 'Recreational Cannabis'],
  Misc: ['Miscellaneous', 'Other'],
  Chemicals: ['Chemicals', 'Chemical', 'Chemical - Histamine'],
  Sports: ['Sports/Fitness', 'Sports/Leisure'],
}
